import { useEffect, useMemo, useState } from 'react';
import { Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import MDButton from '@components/MDButton';
import { NameFilter } from '@components/NameFilter';
import { useMaterialUIController } from 'context';
import { useTranslation } from 'react-i18next';
import { LossReason, LossReasonService } from './services/loss-reason.service';
import { LossReasonTable } from './components/loss-reason.table';
import { LossReasonModal } from './components/loss-reason.modal';

/// Aba Motivos de perda; a busca é local, pois a lista é curta e vem inteira.
export const LossReasonsPanel = () => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const { sidenavColor } = controller;

    const [reasons, setReasons] = useState<LossReason[] | null>(null);
    const [nameFilter, setNameFilter] = useState('');
    const [applied, setApplied] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [editItem, setEditItem] = useState<LossReason | null>(null);

    const load = () =>
        new LossReasonService()
            .list()
            .then((res) => setReasons(res.data.data ?? []))
            .catch(() => setReasons([]));

    useEffect(() => {
        load();
    }, []);

    const visible = useMemo(() => {
        const term = applied.trim().toLowerCase();

        return reasons && term
            ? reasons.filter((reason) => reason.name.toLowerCase().includes(term))
            : reasons;
    }, [reasons, applied]);

    const clear = () => {
        setNameFilter('');
        setApplied('');
    };

    const openFor = (reason: LossReason | null) => {
        setEditItem(reason);
        setOpenModal(true);
    };

    return (
        <>
            <Grid container spacing={1}>
                <NameFilter
                    nameFilter={nameFilter}
                    setNameFilter={setNameFilter}
                    onSearch={() => setApplied(nameFilter)}
                    onClear={clear}
                    onEnter={(e) => e.key === 'Enter' && setApplied(nameFilter)}
                />
                <Grid size={{ xs: 12, md: 2 }} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <MDButton
                        variant="gradient"
                        color={sidenavColor}
                        onClick={() => openFor(null)}
                        sx={{ height: 40, minWidth: 130, whiteSpace: 'nowrap' }}
                    >
                        {t('general.adicionar')}
                    </MDButton>
                </Grid>
            </Grid>

            <Paper sx={{ width: '100%', overflow: 'hidden', mt: 2 }}>
                <LossReasonTable reasons={visible} onEdit={openFor} onChanged={load} />
                <Typography variant="caption" sx={{ display: 'block', px: 2, py: 1.5, color: 'text.secondary' }}>
                    {t('motivosPerda.rodape')}
                </Typography>
            </Paper>

            <LossReasonModal
                open={openModal}
                edit={editItem}
                onClose={() => {
                    setOpenModal(false);
                    setEditItem(null);
                }}
                onSaved={load}
            />
        </>
    );
};
